import React from "react";
import { Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import RecordExistingLoanForm from "./modules/RecordExistingLoanForm";

export default function RecordExistingLoanNew() {
  return (
    <section className="min-vh-100 pb-5">
      <div className="px-lg-3 pt-3 d-flex align-items-center gap-3 mb-2">
        <Link
          to="/super_admin/loan_management/record_existing_loan"
          className="text-decoration-none text-secondary"
          aria-label="Back to migrated loans"
        >
          <BsArrowLeft className="text-xl" />
        </Link>
      </div>
      <RecordExistingLoanForm />
    </section>
  );
}
